<template>
    <el-drawer
        title="批量绑定合同编号"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
            >
                <el-form-item prop="contractSn" label="合同编号:">
                    <el-input
                        v-model="formData.contractSn"
                        placeholder="请输入合同编号"
                        size="medium"
                        maxlength="100"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="ids" label="绑定用户:">
                    <el-select 
                        v-model="formData.ids" 
                        filterable 
                        remote
                        multiple
                        placeholder="请选择需要绑定的用户"
                        :remote-method="searchUser"
                        :loading="userLoading"
                        size="medium">
                        <el-option
                            v-for="item in userList"
                            :key="item.id"
                            :label="`[${$userType.get(item.userType)}]${item.name}`"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">提交</el-button>
        </div>
    </el-drawer>
</template>

<script>

const defaultFormData = {
    contractSn:'',
    ids:[],
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading:false,
            userLoading: false,
            userList:[],
            formData: {
                ...defaultFormData
            },
            rules:{
                contractSn:[{required: true, message: "请输入合同编号"}],
                ids:[{required: true, message: "请选择需要绑定的用户"}],
            },
        }
    },
    methods:{
        close() {
            this.formData = {...defaultFormData};
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(){
            this.drawerShow = true;
        },
        // 搜索用户
        async searchUser(query){
            if(query !== ""){
                this.userLoading = true;
                this.$request({
                    url: "/activity/receivables/getUserInfoByName",
                    method: "POST",
                    params: {userName:query},
                })
                    .then((res) => {
                        //处理成功回调
                        const { state, result } = res.data;
                        if (state && state == 1) {
                            this.userList = result;
                        }
                    })
                    .finally(() => {
                        this.userLoading = false;
                    });
            }
        },
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: "/activity/receivables/batchUpdate",
                        method: "POST",
                        params: {...this.formData, ids: this.formData.ids.toString()},
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.$message.success('操作成功');
                                this.close();
                                this.$emit('onUpdate');
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            })
        }
    }
}
</script>